import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchActivityLogList,
  searchActivityLog,
  resetDieCategoryListThunk, // Verify if this is correct
  setSearchTerm,
} from '../../slices/activity-log';
import {
  Table,
  Typography,
  Spin,
  Row,
  Col,
  Input,
  Button,
  Breadcrumb,
  Pagination,
  message,
} from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { SearchOutlined } from '@ant-design/icons';

const { Title } = Typography;
const { Search } = Input;

function ActivityList() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    list: activityLog,
    loading,
    currentPage,
    totalPages,
    totalRecord,
    searchTerm,
  } = useSelector((state) => state.activityLog);

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(100); 
   const {user: currentUser} = useSelector(state => state.auth);

  useEffect(() => {
    dispatch(
      fetchActivityLogList({
        page,
        pageSize,
        search: searchTerm,
      }),
    ).then((response) => {
      if (response.error) {
        message.error('Failed to fetch activity logs');
        console.error('Fetch error:', response.error);
      }
    });
  }, [dispatch, page, pageSize, searchTerm]);

 

  const handleSearch = (value) => {
    setPage(1);
    dispatch(setSearchTerm(value));
    dispatch(searchActivityLog({ search: value, page: 1, pageSize }));
  };

  const handleReset = () => {
    setPage(1);
    setPageSize(100);
    dispatch(setSearchTerm(''));
    dispatch(resetDieCategoryListThunk()).then(() => {
      dispatch(fetchActivityLogList({ page: 1, pageSize: 100, search: '' }));
    });
  };

  const handlePageChange = (newPage, newPageSize) => {
    setPage(newPage);
    if (newPageSize !== pageSize) {
      setPageSize(newPageSize);
      setPage(1);
    }
  };

  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'SrNo',
      key: 'SrNo',
      width: 100,
      render: (text, record, index) => (page - 1) * pageSize + index + 1,
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      width: 120,
    },
    {
      title: 'Module',
      dataIndex: 'module_name',
      key: 'module_name',
      width: 140,
    },
    {
      title: 'Performed By',
      dataIndex: 'action_by_name',
      key: 'action_by_name',
      width: 150,
    },
     {
      title: 'Performed At',
      dataIndex: 'timestamp',
      key: 'timestamp',
      width: 150,
      render: (text) => dayjs(text).format('DD-MM-YYYY HH:mm'),
    },
     {
      title: 'IP Address',
      dataIndex: 'ip_address',
      key: 'ip_address',
      width: 150,
      render: (text) => text || 'N/A',
    },
   
    {
      title: 'Description',
      dataIndex: 'discription',
      key: 'discription',
      width: 200,
    },
   
  ];

  return (
   <div className='mainwrap'>
      <div className="sticyaction">
        <Row className="pagenamerow mb-0"   justify="space-between" align="middle">
          <Col span={19}>
            <h2>Activities</h2>
            <div className="bredcrumbwrp">
              <Link onClick={() => navigate(-1)} className="back">
                BACK
              </Link>
              <Breadcrumb
                items={[
                  { title: <Link to="/dashboard">Home</Link> },
                  { title: 'Activities' },
                ]}
              />
            </div>
          </Col>
          <Col span={3}>
            <Input
              placeholder="Search activity"
               prefix={<SearchOutlined />}
              value={searchTerm}
              onChange={(e) => dispatch(setSearchTerm(e.target.value))}
              onSearch={handleSearch}
              allowClear
              
            />
          </Col>
          <Col span={1}>
            <Button onClick={handleReset} type="primary">
              Reset
            </Button>
          </Col>
        </Row>
      </div>
<div className='tablewrp activity'>
      <Spin spinning={loading} >
       <div className='tablewrp' >
            <Table
              columns={columns}
              dataSource={activityLog}
              rowKey="id"
              pagination={false}
              scroll={{ x: 'max-content' }}
              locale={{ emptyText: 'No activity logs found.' }}
            />
          </div>
        
            <Pagination
              current={page}
              pageSize={pageSize}
              total={totalRecord}
              showSizeChanger
              pageSizeOptions={['10', '50', '100']}
              showTotal={(total) => `Total ${total} items`}
              onChange={handlePageChange}
              locale={{ items_per_page: 'Items / Page' }}
            />
        
      </Spin>
      </div>
    </div>
  );
}

export default ActivityList;